import lozad from 'lozad'
import AppBase from 'app-base'
import CustomerName from 'frontend/layout/customer-name'
import RepaintHeader from './lib/repaint-header'
import Order from 'models/order'
import KioskMode from './lib/kiosk-mode'
import FlashMessages from 'lib/flash-messages'

const App = window.FrontendApp = window.FrontendApp || class extends AppBase {
  static init () {
    super.init()
    this.geolocation = {}
  }

  static handleDOMReady () {
    if (this.DOMReadyHandled) return
    super.handleDOMReady()
    CustomerName()
    KioskMode()
  }

  static handleStylesApplied () {
    super.handleStylesApplied()
    this.initLazyLoad()
    RepaintHeader.init()
  }

  static initLazyLoad () {
    this.lazyLoad = lozad('.lazy', {
      loaded: el => el.classList.add('lazy_loaded'),
    })
    this.lazyLoad.observe()
  }

  // static mountTeaser () {
  //   const el = document.createElement('div')
  //   document.body.appendChild(el)
  //   ReactDOM.render(<Teaser />, el)
  // }

  static resetCurrentOrder () {
    this.currentOrder = undefined
  }

  static get currentOrder () {
    return (async () => {
      // Wait for the session cookie to be established before touching order state.
      await FlashMessages.ready.catch(() => {})

      if (this._currentOrder !== undefined) return this._currentOrder
      if (this._fetchOrderPromise) return await this._fetchOrderPromise()

      this._fetchOrderPromise = async () => {
        try {
          this._currentOrder = await Order.retrieve({ resourcePath: '/order' })
        } finally {
          if (!this._currentOrder?.id) {
            this._currentOrder = this.buildOrder()
          }
          this._fetchOrderPromise = null
        }

        return this._currentOrder
      }

      return await this._fetchOrderPromise()
    })()
  }

  static set currentOrder (order) {
    this._currentOrder = this.ensureOrderEligableState(this.ensureIsOrder(order))
  }

  static ensureIsOrder (something) {
    if (something instanceof Order) return something

    return this.buildOrder(something)
  }

  static ensureOrderEligableState (order) {
    if (['payment', 'cart'].includes(order.state)) return order

    return this.buildOrder()
  }

  static buildOrder (attrs = {}) {
    return new Order({ attrs, resourcePath: '/order' })
  }
}

AppBase.current = App

if (!App.initialized) {
  App.init()
}

export default App
